import React, { useState } from "react";
import "./CryptoPromo.css";

export default function CryptoPromo() {
  const [showCrypto, setShowCrypto] = useState(false);

  return (
    <>
      {/* Floating Tab */}
      {/* Removed crypto discount promo */}

      {/* Modal */}
      {showCrypto && (
        <div
          className="crypto-modal-overlay"
          onClick={() => setShowCrypto(false)}
        >
          <div
            className="crypto-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>💎 20% OFF with Ethereum Payment</h3>
            <p>
              Scan the QR code or copy the wallet address below to complete your payment.
            </p>

            <img
              src="/eth-qr.png"
              alt="Ethereum QR"
              className="qr-code pulse"
            />

            <div className="wallet-address">
              <code id="eth-address">
                0x1234567890ABCDEF1234567890ABCDEF12345678
              </code>
              <button
                className="copy-btn purple"
                onClick={() => {
                  navigator.clipboard.writeText(
                    "0x1234567890ABCDEF1234567890ABCDEF12345678"
                  );
                  alert("✅ Ethereum address copied!");
                }}
              >
                Copy
              </button>
            </div>

            <p className="note">
              ⚡ You’ll receive 20% off your first month by paying with Ethereum.  
              Once confirmed, please show your transaction to the front desk.
            </p>
          </div>
        </div>
      )}
    </>
  );
}
